import { render, staticRenderFns } from "./clear.vue?vue&type=template&id=4e88c040&scoped=true"
import script from "./clear.vue?vue&type=script&lang=js"
export * from "./clear.vue?vue&type=script&lang=js"
import style0 from "./clear.vue?vue&type=style&index=0&id=4e88c040&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e88c040",
  null
  
)

export default component.exports